export default __webpack_public_path__ + "media/images/wedding-marque-987133efb16301eafe8eef03719e5578.png";